import { ReduxAction } from '../interfaces'
import { MessagesState } from './interfaces'

// Action Types
export const SET_MESSAGES_COUNT = 'SET_MESSAGES_COUNT'

//Actions
export const setMessagesCount = (data: MessagesState): ReduxAction => {
  return { type: SET_MESSAGES_COUNT, payload: data }
}
